import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

import type { TrackingData } from '@ecomm/tracking-types/Data'

export function useTrackingFaqExpand() {
  const { trackEvent } = useTracking<TrackingData>()
  return useCallback(
    (index: number) => {
      trackEvent({
        event: 'faq-expand',
        faqPosition: index
      })
    },
    [trackEvent]
  )
}
